import axios from 'axios'
import mutations from '@/store/mutation-types'
import actions from '@/store/action-types'

export default {
  state: {
    nick: '',
    avatar: '',
    joinRanking: 0,
    totalDuration: 0,
    remainingDuration: 0,
    durationOfToday: 0,
    donationObjects: []
  },
  getters: {
    donationObject: state => {
      if (state.donationObjects.length > 0) {
        return state.donationObjects[0].name
      } else {
        return ''
      }
    },
    donationObjects: state => {
      const list = []
      state.donationObjects.forEach(item => {
        list.push(item.name)
      })
      return list
    }
  },
  mutations: {
    [ mutations.update.USER_OVERVIEW ] (state, payload) {
      state.remainingDuration = payload.remainingDuration
      state.durationOfToday = payload.durationOfToday
    },
    [ mutations.update.USER_SUMMRAY ] (state, payload) {
      state.nick = payload.nick
      state.avatar = payload.avatar
      state.joinRanking = payload.joinRanking
      state.totalDuration = payload.totalDuration
      state.donationObjects = payload.donationObjects
    }
  },
  actions: {
    [ actions.fetch.USER_OVERVIEW ] ({ commit, rootState }) {
      return axios.get(`${rootState.API_BASE_URL}/overview`, {
        params: rootState.urlParams
      }).then(({ data }) => {
        commit(mutations.update.USER_OVERVIEW, data)
      }).catch(error => {
        console.log(`${actions.fetch.USER_OVERVIEW}: ${error}`)
      })
    },
    [ actions.post.DONATE_COURSE ] ({ dispatch, rootState }, payload) {
      return axios.post(`${rootState.API_BASE_URL}`, {
        ...rootState.urlParams,
        duration: payload.duration
      }).then(({ data }) => {
        if (data.success) {
          dispatch(actions.fetch.USER_OVERVIEW)
          dispatch(actions.fetch.USER_SUMMRAY)
          dispatch(actions.fetch.GROUP_LEADERBOARD)
          dispatch(actions.fetch.LATEST_DONATE)
        }
      }).catch(error => {
        console.log(`${actions.post.DONATE_COURSE}: ${error}`)
      })
    },
    [ actions.fetch.USER_SUMMRAY ] ({ commit, rootState }) {
      return axios.get(`${rootState.API_BASE_URL}/summary`, {
        params: rootState.urlParams
      }).then(({ data }) => {
        commit(mutations.update.USER_SUMMRAY, data)
      }).catch(error => {
        console.log(`${actions.fetch.USER_SUMMRAY}: ${error}`)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/overview.js